import {
    Box
} from '@mui/material';
import {
    type FC
} from 'react';

import type {
    SectionProps
} from './types';

import styles from './styles';

const Section: FC<SectionProps> = (props) => {
    const {
        children,
        horizontalPadding = 'shallow',
        sx,
        ...boxProps
    } = props;

    return (
        <Box
            {...boxProps}
            component={'section'}
            sx={[
                sx,
                styles.default,
                ...(Array.isArray(styles[horizontalPadding]) ? styles[horizontalPadding] : [
                    styles[horizontalPadding]
                ])
            ]}
        >
            {children}
        </Box>
    );
};

export default Section;
